import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { supportedLanguages } from '../../../helpers/LanguageHelper';
import useCheckoutActivity from '../../../helpers/useCheckoutActivity';

export function activityPage(pathname) {
    const parts = pathname.toLowerCase().split('/').filter(Boolean);
    if (supportedLanguages.includes(parts[0])) parts.shift();
    const page = parts[0] || '';
    const stages = { cart: 'Cart', 'orders-history': 'Orders', orderconfirm: 'Completed' };
    // Checkout reports its own payment UI state. One reporter per page.
    return { stage: page === 'checkout' ? null : stages[page] || 'Browsing', pagePath: '/' + page };
}

export default function CustomerPageActivity() {
    const userJson = useSelector(state => state.userReducer.user);
    let userId;
    try { userId = JSON.parse(userJson || '{}')?.UserID; } catch { /* No valid session. */ }
    const { pathname } = useLocation();
    const { stage, pagePath } = activityPage(pathname);
    useCheckoutActivity(stage, userId, pagePath);
    return null;
}
